<mat-card>
    <div class="mat-card-header">
        <h2>MSc Computer Science</h2>
    </div>
    <mat-card-content>
        <div class="titles">
            <mat-card-title>MSc Computer Science</mat-card-title>
            <mat-card-title>2021-2022</mat-card-title>
        </div>
        <mat-card-subtitle>University Of Bath</mat-card-subtitle>
        
        <p>Expected First Class Honours</p>
    </mat-card-content>
</mat-card> 
